import React from 'react';
import TypeControlledTextField from '../../../../tc-ui/type-controlled-textfield.jsx';
import Icon from '../../../../tc-ui/icon';
import { SelectField, MenuItem } from 'material-ui';

const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";

const SingleAllocation = ({
  style,
  index,
  allocationType,
  allotments,
  releaseBackDays,
  numberOfRooms,
  onTextFieldChangeWithKeyPath,
  addOneElementWithKeyPath,
  deleteOneElementWithKeyPath,
  showError,
}) => {
  return (
    <div style={{ width: '50%', marginLeft: '25%', ...style }}>
      <SelectField
        hintText="Please select"
        hintStyle={{ fontSize: '14px', fontFamily }}
        style={{ width: '40%' }}
        labelStyle={{ fontSize: '14px', fontFamily, paddingLeft: '0', textAlign: 'center' }}
        underlineStyle={{ marginLeft: '0px' }}
        value={allocationType}
        onChange={(event, _, value) => {
          onTextFieldChangeWithKeyPath({ keyPath: [index, 'allocationType'], value });
          if (value === 'allotment') onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments'], value: [{}] });
        }}
      >
        <MenuItem value="onRequest" primaryText="On request"/>
        <MenuItem value="freesale" primaryText="Freesale"/>
        <MenuItem value="allotment" primaryText="Allotment"/>
      </SelectField>
      <div style={{ position: 'relative' }}>
        {allocationType === 'allotment' && allotments && allotments.length ? allotments.map((allotment, allotmentIndex) => (
          <div key={allotmentIndex} style={{ display: 'flex' }}>
            <TypeControlledTextField
              controlledType="number"
              floatingLabelText={'# of passengers/rooms'}
              hintText="Number only"
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px', marginTop: '0' }}
              floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
              style={{ width: '40%', marginRight: '18px', height: '48px', fontFamily }}
              errorStyle={{ fontSize: '10px', bottom: '10px' }}
              errorText={showError && !allotment.numberOfRooms ? 'Required' : ''}
              underlineStyle={{ bottom: '10px' }}
              value={allotment.numberOfRooms}
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex, 'numberOfRooms'], value })}
            />
            <TypeControlledTextField
              controlledType="number"
              floatingLabelText="Release back days"
              hintText="Number only"
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px', marginTop: '0' }}
              floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
              style={{ width: '35%', height: '48px', fontFamily }}
              errorStyle={{ fontSize: '10px', bottom: '10px' }}
              errorText={showError && !allotment.releaseBackDays ? 'Required' : ''}
              underlineStyle={{ bottom: '10px' }}
              value={allotment.releaseBackDays}
              onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex, 'releaseBackDays'], value })}
            />
            {
              allotmentIndex === allotments.length - 1 ? <Icon
                className="tc-icon-add"
                style={{
                  marginLeft: '16px',
                  height: '28px',
                  lineHeight: '24px',
                  verticalAlign: 'middle',
                  border: '2px solid green',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  alignSelf: 'center',
                }}
                onClick={() => addOneElementWithKeyPath({ keyPath: [index, 'allotments'], element: {} })}
              /> : <Icon
                className="tc-icon-close"
                style={{
                  marginLeft: '16px',
                  height: '28px',
                  lineHeight: '24px',
                  verticalAlign: 'middle',
                  color: '#ff4081',
                  cursor: 'pointer',
                  alignSelf: 'center',
                }}
                onClick={() => deleteOneElementWithKeyPath({ keyPath: [index, 'allotments', allotmentIndex] })}
              />
            }
          </div>
        )) : undefined}
        {
          allocationType === 'freesale' ? (
            <div>
              <TypeControlledTextField
                controlledType="number"
                floatingLabelText={'# of passengers/rooms'}
                hintText="Number only"
                hintStyle={{ fontSize: '12px' }}
                inputStyle={{ fontSize: '14px', marginTop: '0' }}
                floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
                style={{ height: '48px', fontFamily, top: '-10px', width: '150px' }}
                errorStyle={{ fontSize: '10px', bottom: '10px' }}
                errorText={showError && !numberOfRooms ? 'Required' : ''}
                underlineStyle={{ bottom: '10px' }}
                value={numberOfRooms}
                onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: [index, 'numberOfRooms'], value })}
              />
              <TypeControlledTextField
                controlledType="number"
                floatingLabelText="Release back days"
                hintText="Number only"
                hintStyle={{ fontSize: '12px' }}
                inputStyle={{ fontSize: '14px', marginTop: '0' }}
                floatingLabelStyle={{ fontSize: '12px', top: '18px' }}
                style={{ height: '48px', fontFamily, top: '-10px', width: '35%', marginLeft: '8px' }}
                errorStyle={{ fontSize: '10px', bottom: '10px' }}
                errorText={showError && !releaseBackDays ? 'Required' : ''}
                underlineStyle={{ bottom: '10px' }}
                value={releaseBackDays}
                onChange={({ target: { value } }) => onTextFieldChangeWithKeyPath({ keyPath: [index, 'releaseBackDays'], value })}
              />
            </div>
            ) : undefined
        }
      </div>
    </div>
  );
};

export default SingleAllocation;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/allocation/single-allocation-node.jsx